import React from "react";
// import "../stylesChonky.css";
import { Grid, styled, IconButton, Link, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
	ChevronLeft as ArrowBack,
	ChevronRight as ArrowForward,
	Autorenew,
	ArrowUpward,
	NavigateNext,
} from "@mui/icons-material";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { WindowContent } from "../../desktopWindow/components/DesktopWindow";
import { getInvertColor } from "utils/themeUtils";
import { useFileBrowserContainer } from "fileBrowser/hooks/filesHooks";
import { isDesktop } from "react-device-detect";
import FileViewer from "./FileViewer";
import { DocumentModal } from "components/DocumentModal";
import { ActionBar } from "desktopWindow/components/DesktopWindow.styled";
import FileBrowser from "./FileBrowser";

// setChonkyDefaults({ iconComponent: ChonkyIconFA });

const FileBrowserContainer: React.FC<{ instanceId: string }> = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const {
		files,
		currentFolderId,
		pastFolder,
		upcomingFolder,
		currentFolderFiles,
		folderChain,
		hasParent,
		isFile,
		fileComponentProps,
		handleSelectFolder,
		onBack,
		onForward,
		onRefresh,
		onUpward,
		handleFileAction,
		renderSubTree,
		handleFileForMobile,
		closeUnlockFileModal,
		protectedFilePayload,
	} = useFileBrowserContainer();

	return (
		<>
			{currentFolderId !== "Home" && !isFile && (
				<FileBrowserHeader>
					<Grid container direction="row" justifyContent="space-between" alignContent="center">
						<Grid item xs={3} style={{ color: getInvertColor(theme.palette.primary.main) }}>
							<IconButton
								color="inherit"
								disabled={pastFolder.length < 2}
								onClick={onBack}
								className={`${classes.icon} ${classes.iconBackwards}`}
								size="large"
							>
								<ArrowBack />
							</IconButton>
							<IconButton
								color="inherit"
								disabled={upcomingFolder.length < 1}
								onClick={onForward}
								className={classes.icon}
								size="large"
							>
								<ArrowForward />
							</IconButton>
							{isDesktop && (
								<>
									<IconButton color="inherit" onClick={onRefresh} style={{ padding: 6 }} size="large">
										<Autorenew />
									</IconButton>
									<IconButton color="inherit" disabled={!hasParent} onClick={onUpward} size="large">
										<ArrowUpward />
									</IconButton>
								</>
							)}
						</Grid>
						<Grid
							item
							container
							xs={9}
							style={{ backgroundColor: "#fff", borderRadius: 5, paddingLeft: 20 }}
						>
							{folderChain.map((folder) => {
								if (folder?.isDir) {
									return (
										<div key={folder.id} style={{ display: "flex", alignSelf: "center" }}>
											<Link
												component="button"
												color="inherit"
												onClick={() => handleSelectFolder(folder.id)}
												sx={{ fontSize: "0.875rem", textDecoration: "none" }}
											>
												{folder.name}
											</Link>
											<NavigateNext />
										</div>
									);
								}
								return null;
							})}
						</Grid>
					</Grid>
				</FileBrowserHeader>
			)}
			<WindowContent>
				<Grid container direction="row" style={{ height: "100%", overflow: "hidden" }}>
					{isDesktop && (
						<Grid item xs={3} style={{ paddingTop: 15, boxShadow: "0.1px 0.1px 6px grey", zIndex: 10 }}>
							<TreeView selected={currentFolderId}>
								{files?.map((file) => {
									if (file?.isRootDir) {
										return renderSubTree(file!.id);
									}
									return null;
								})}
							</TreeView>
						</Grid>
					)}
					<Grid
						item
						xs={9}
						style={{
							overflowY: "auto",
							flexBasis: isDesktop ? "75%" : "100%",
							maxWidth: isDesktop ? "75%" : "100%",
							height: "100%",
						}}
					>
						{/* {!isFile && (
							<FileBrowser
								instanceId={props.instanceId}
								files={currentFolderFiles}
								onFileAction={handleFileAction}
								disableDragAndDrop
								disableDragAndDropProvider
								disableSelection
							>
								<div className={classes.styledFileList}>
									<FileList />
								</div>
							</FileBrowser>
						)} */}
						{!isFile && <FileBrowser files={currentFolderFiles} handleFileAction={handleFileAction} />}
						{isFile && (
							<FileViewer
								file={fileComponentProps!.componentProps.file}
								size={fileComponentProps!.componentProps.size}
								handleFileForMobile={handleFileForMobile}
								name={undefined}
								openFromApp={true}
							/>
						)}
					</Grid>
				</Grid>
			</WindowContent>
			<DocumentModal isOpen={!!protectedFilePayload} onClose={closeUnlockFileModal} data={protectedFilePayload} />
		</>
	);
};

const FileBrowserHeader = styled(ActionBar)({
	padding: "16px 24px 16px 8px",
});

//thestyled Component can't read the theme.

// const StyledFileList = styled("div")(({ theme }) => ({
// 	backgroundColor: "#F8F8F8 !important",
// 	margin: "-10px -8px -10px -8px",
// 	padding: "10px 5px 10px 10px",
// 	height: "521px",
// 	color: () => {
// 		console.log(theme);
// 		return "blue";
// 	},
// 	[theme.breakpoints.down("mobile")]: {
// 		paddingTop: 20,
// 		height: "100%",
// 	},
// }));

const useStyles = makeStyles((theme) => ({
	styledFileList: {
		backgroundColor: "#F8F8F8 !important",
		margin: "-10px -8px -10px -8px",
		padding: "10px 5px 10px 10px",
		height: "521px",
		width: "100%",
		columnGap: 10,
		fontSize: "0.875rem",
		[theme.breakpoints.down("mobile")]: {
			padding: "20px 10px",
			height: "102%",
		},
	},
	icon: {
		padding: 6,
		[theme.breakpoints.down("smallMobile")]: {
			padding: 0,
		},
	},
	iconBackwards: {
		marginLeft: 10,
		[theme.breakpoints.down("smallMobile")]: {
			marginLeft: 0,
			marginRight: 5,
		},
	},
}));

export default React.memo(FileBrowserContainer);
